export const environment = {
    apiUrl: 'https://dev-api.zignflix.com/admin-api/',
    zignFlixApiUrl: 'https://dev-api.zignflix.com/api/',
    zignFlixUrl: 'https://dev-studio.zignflix.com/'
};